var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSea1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9042 0.101562L19.8037 1.51577L21.2179 11.4153L12.0255 20.6076C11.635 20.9982 11.0019 20.9982 10.6113 20.6076L0.711843 10.7082C0.321313 10.3176 0.321313 9.68451 0.711843 9.29391L9.9042 0.101562ZM10.6113 2.22288L2.83316 10.001L11.3184 18.4863L19.0966 10.7082L18.036 3.28354L10.6113 2.22288ZM12.7327 8.58681C11.9516 7.80579 11.9516 6.53946 12.7327 5.75841C13.5137 4.97737 14.78 4.97737 15.5611 5.75841C16.3421 6.53946 16.3421 7.80579 15.5611 8.58681C14.78 9.36791 13.5137 9.36791 12.7327 8.58681Z",
    fill: "#416EB2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSea1);
export default __webpack_public_path__ + "static/media/sea-1.c863760f84fc0062835e1d2a5dc60d41.svg";
export { ForwardRef as ReactComponent };